(() => {
  !(function (e, t, n, s, u, a) {
    e.twq ||
      ((s = e.twq =
        function () {
          s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
        }),
      (s.version = "1.1"),
      (s.queue = []),
      (u = t.createElement(n)),
      (u.async = !0),
      (u.src = "https://static.ads-twitter.com/uwt.js"),
      (a = t.getElementsByTagName(n)[0]),
      a.parentNode.insertBefore(u, a));
  })(window, document, "script");
  twq("config", "o8tng");
})();

// Search Trigger, only on search results page.
(() => {
  function twitterSearchEvent() {
    const bodyElement = document.querySelector("body");
    const searchTerms = bodyElement.dataset.searchTerms || "";
    if (!searchTerms) return;
    const eventData = {
      search_string: searchTerms,
    };
    twq("event", "tw-o8tng-oe1bi", eventData);
  }
  twitterSearchEvent();
})();

// View Product Event
(() => {
  async function twitterViewProduct(product, variant) {
    if (!product || !variant) return;
    try {
      const eventData = {
        value: variant.price_without_currency, // use this to pass the value of the conversion (e.g. 5.00)
        currency: window.theme.currency.code, // use this to pass the currency of the conversion with an ISO 4217 code (e.g. ‘USD’)
        contents: [
          {
            content_type: product.type,
            content_id: variant.id,
            content_name: `${product.title} - ${variant.title}`,
            content_price: variant.price_without_currency,
            num_items: 1,
            content_group_id: product.id,
          },
        ],
      };
      twq("event", "tw-o8tng-oe1bg", eventData);
    } catch (error) {
      console.error(error);
    }
  }

  async function triggerViewEvent(product, variant) {
    await Promise.all([twitterViewProduct(product, variant)]);
  }

  document.addEventListener("product-overview:initialized", async (event) => {
    await triggerViewEvent(event.detail.product,event.detail.variant);
  });
})();
